// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/temperature-inversions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/temperature-inversions/temperature-inversions.js';

mount([g0]);
